/**
 * 관제 콘솔(실시간 주차 관제 · ROI 편집) 전용 디자인 토큰.
 *
 * 두 화면은 "도면 + 카메라 영상"을 하루 종일 들여다보는 작업 화면이라,
 * 일반 관리 페이지(Card 나열)와 다른 규칙이 필요하다:
 *   - 표면은 어둡고 낮은 채도 — 영상/도면이 주인공이고 UI 는 배경이어야 한다.
 *   - 스테이지(도면·영상)는 라이트 모드에서도 어둡게 고정. SiteMapCanvas 가
 *     offline-manage 팔레트(#0f1620 위 밝은 선)를 그대로 쓰기 때문.
 *   - 강조는 한 가지 악센트(청록)로만. 상태는 ok/warn/danger 3색.
 *
 * workflowTokens(운영 템플릿) 과 같은 방식: 라이트/다크 두 벌을 정의하고
 * palette.mode 로 고른다.
 */
export const CONSOLE_LIGHT = {
  /** 셸 바탕 */
  bg: '#eef1f5',
  /** 패널(레일·인스펙터·헤더) 표면 */
  panel: '#ffffff',
  /** 패널 안 한 단계 낮은 표면(필터 바, 그룹 헤더) */
  panelSoft: '#f4f6f9',
  line: '#dde2e9',
  lineSoft: '#e8ecf1',
  ink: '#1b2430',
  sub: '#5b6775',
  faint: '#8c97a5',
  accent: '#0f9f8f',
  accentSoft: 'rgba(15,159,143,0.12)',
  ok: '#2e9e5b',
  warn: '#b7791f',
  danger: '#c0453a',
  /** 도면·영상 스테이지 — 모드와 무관하게 어둡다 */
  stage: '#0f1620',
  stageLine: 'rgba(255,255,255,0.10)',
  stageInk: '#e6edf6',
  mono: "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
} as const;

export type ConsoleTokens = Record<keyof typeof CONSOLE_LIGHT, string>;

export const CONSOLE_DARK: ConsoleTokens = {
  bg: '#0c1118',
  panel: '#131a24',
  panelSoft: '#18212d',
  line: '#26303d',
  lineSoft: '#1e2733',
  ink: '#e6edf6',
  sub: '#9aa7b6',
  faint: '#6d7a8a',
  accent: '#2dd4bf',
  accentSoft: 'rgba(45,212,191,0.14)',
  ok: '#37d39b',
  warn: '#d8a23a',
  danger: '#e2735f',
  stage: '#0f1620',
  stageLine: 'rgba(255,255,255,0.10)',
  stageInk: '#e6edf6',
  mono: CONSOLE_LIGHT.mono,
};

/** 앱 테마 모드에 맞는 콘솔 토큰. */
export function consoleTokens(mode?: string): ConsoleTokens {
  return mode === 'dark' ? CONSOLE_DARK : CONSOLE_LIGHT;
}
